
/* CHEECASE Scroll Reveal */

(() => {
  const selector = '.cheecase-reveal';

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;

    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    elements.forEach((element) => {
      if (element.dataset.revealInitialized) return;
      element.dataset.revealInitialized = 'true';
      observer.observe(element);
    });
  }

  function startReveal() {
    if (window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches) return;

    if (!('IntersectionObserver' in window)) return;

    document.documentElement.classList.add(
      'cheecase-reveal-ready'
    );

    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startReveal,
      { once: true }
    );
  } else {
    startReveal();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
